module.exports = __webpack_public_path__ + "img/十二篮logo图.a8c026f0.png";